<template>
  <div class="general-info listing-department-list-block">
    <div class="general-info__container">
      <div v-if="heading" class="general-info__title-left">
        <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">{{ heading }}</h1>
      </div>
      <AppLoader v-if="isLoading" />
      <template v-else>
        <AppDepartmentItem
          v-for="department in displayDepartments"
          :key="department.id || department.name"
          :item_department="department"
        />
      </template>
    </div>
  </div>
</template>

<script>
import AppDepartmentItem from '@/components/Departments/DepartmentItem.vue'
import AppLoader from '@/components/Loader.vue'
import { actionTypesDepartment } from '@/store/modules/department'
import { mapState } from 'vuex'

export default {
  name: 'AppDepartmentListBlock',
  components: { AppDepartmentItem, AppLoader },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      localLoading: false,
    }
  },
  computed: {
    ...mapState({
      storeDepartments: (state) => state.department.departments,
      storeLoading: (state) => state.department.isLoading,
    }),
    heading() {
      return (this.data && this.data.heading) || ''
    },
    source() {
      return (this.data && this.data.source) === 'manual' ? 'manual' : 'api'
    },
    isLoading() {
      return this.source === 'api' && (this.localLoading || this.storeLoading)
    },
    displayDepartments() {
      if (this.source === 'manual') {
        const list = (this.data && this.data.items) || []
        if (!Array.isArray(list)) return []
        return list.map((card, idx) => ({
          id: `manual-${idx}-${card.name || ''}`,
          name: card.name || '',
          image: card.image || '',
          links: card.link || '',
          items: Array.isArray(card.underItems)
            ? card.underItems.filter((n) => String(n || '').trim())
            : [],
        }))
      }
      return this.storeDepartments || []
    },
  },
  watch: {
    source: {
      immediate: true,
      handler(val) {
        if (val === 'api') this.loadDepartments()
      },
    },
  },
  methods: {
    loadDepartments() {
      this.localLoading = true
      this.$store
        .dispatch(actionTypesDepartment.getDepartment)
        .catch(() => {})
        .finally(() => {
          this.localLoading = false
        })
    },
  },
}
</script>

<style scoped>
</style>
